/** Chains pointer handlers so dnd-kit and long-press both receive events. */
const POINTER_HANDLER_KEYS = [
  'onPointerDown',
  'onPointerUp',
  'onPointerMove',
  'onPointerCancel',
];

const composeHandler =
  (...handlers) =>
  (event) => {
    for (const handler of handlers) {
      if (handler) handler(event);
    }
  };

/**
 * Merges dnd-kit sortable listeners with long-press handlers without clobbering
 * `onPointerDown` — the root cause of panel→calendar drags failing on touch-capable
 * narrow desktops when long-press spread came after listeners.
 *
 * @param {Record<string, Function|undefined>} primary — dnd-kit listeners (first)
 * @param {Record<string, Function|undefined>} secondary — long-press handlers
 */
export function composePointerHandlers(primary = {}, secondary = {}) {
  /** @type {Record<string, Function|undefined>} */
  const merged = {};
  for (const key of POINTER_HANDLER_KEYS) {
    const composed = composeHandler(primary[key], secondary[key]);
    const hasHandler = primary[key] || secondary[key];
    if (hasHandler) merged[key] = composed;
  }
  return merged;
}
